<template>
  <div class="commissionDetail_warpper">
    <nav-bar @goBack="goBack" height="30px"></nav-bar>
    <div class="contentBox">
      <div class="detail_title">待债权人确认</div>
      <van-row  class="introduce_row">
        <van-col class="debtor_introduce" span="10">
          <div class="introduceBody">
            <p class="introduce_type">债务人</p>
            <p class="introduce_name">真实姓名</p>
            <p class="introduce_tel">15909812223</p>
            <p class="introduce_code">****0016</p>
          </div>
        </van-col>
        <van-col class="process" span="4">
          <div class="processBody">
            <p class="reimbursement">还款</p>
            <div class="process_icon">
              <van-icon class="phase" name="play" :style="{ color: 'gray'}" />
              <van-icon class="phase" name="play" :style="{ color: 'gray'}" />
              <van-icon class="phase" name="play" :style="{ color: 'gray'}" />
            </div>
          </div>
        </van-col>
        <van-col class="creditors_introduce" span="10">
          <div class="creditorsBody">
            <p class="introduce_type">债权人</p>
            <p class="introduce_name">真实姓名</p>
            <p class="introduce_tel">15909812223</p>
            <p class="introduce_code">{{this.code}}</p>
          </div>
        </van-col>
      </van-row>
      <div class="order_details">
        <p class="order_title">订单详情</p>
        <p class="order_content">解债金额 ¥100000.00</p>
        <p class="order_content">减免债务金额 ¥65000.00</p>
        <p class="order_content">经纪人代码 21312356466</p>
        <p class="order_content">订单号 654436132</p>
        <p class="order_content">提交时间 2020.07.12 19:2</p>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  name: "commissionDetail",
  data() {
    return {
      has_payment: "5633.33", //已还款
      total_amount: "360000.000", //总还款
      operation_loading: false, //发送请求避免重复提交
      // (parseInt(this.total_amount)) <= 0 ? "0" : (Math.round(parseInt(this.has_payment) / parseInt(this.total_amount) * 10000) / 100.00).toString(),
      // '50',//进度百分比
      callBack: "撤回", //查看电子合同/驳回//撤回/查看电子合同/删除订单
      operation_text: "提交", //签署电子合同/提交/通过/签署合同
      code: "****" + "5656895".substr(4, "5656895".split("").length), //代码前四位*号代替
    };
  },
  components: {
    navBar,
  },
  created() {
   
  },
  methods: {
  },
  mounted: {
    goBack() {
      // this.params("", "", "goBack");
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less">
.commissionDetail_warpper {
  background-color: #f5f6f7;
  min-height: 100%;
  color: #333333;
  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .contentBox {
   margin: 12px 18px;
    
  
    .has_payment {
      font-size: 24px;
      font-weight: 600;
    }
    .total_amount {
      font-size: 16px;
      color: #999999;
    }
    .detail_title {
      font-size: 24px;
      font-weight: 600;
      margin: 18px 0 24px;
    }
    .introduce_row {
      margin-bottom: 20px;
    }
    .introduceBody,
    .creditorsBody {
      background-color: #fff;
      width: 153px;
      height: 139px;
      -webkit-box-shadow: 0px 0px 1px #000;
      box-shadow: 0px 0px 4px #dedada;
      text-align: center;
      border-radius: 6px;
      .introduce_type {
        color: #999999;
        font-size: 13px;
        padding: 15px 0 6px;
      }
      .introduce_name {
        color: #fc740c;
        font-size: 17px;
        height: 28px;
        font-weight: 600;
        line-height: 28px;
      }
      .introduce_tel {
        font-size: 15px;
        margin: 3px 0;
        height: 24px;
        line-height: 24px;
      }
      .introduce_code {
        color: #999999;
        font-size: 15px;
        padding-bottom: 14px;
        height: 24px;
        line-height: 24px;
      }
    }
    .process {
      text-align: center;
      height: 150px;
      .processBody {
        margin-top: 52px;
        .reimbursement {
          font-size: 15px;
        }
        .process_icon {
          .phase {
            width: 12px;
            height: 12px;
            margin: 6px 0px 0 0;
          }
        }
      }
    }
    .order_details {
      margin: 4px 0 0;
      width: 100%;
      background-color: #fff;
      font-size: 14px;
      border-radius: 6px;
      padding-bottom: 24px;
      .order_title {
        color: #999999;
        padding: 15px 0 10px;
        margin-left: 15px;
      }
      .order_content {
        padding-bottom: 6px;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      p {
        .van-uploader__preview-image {
          width: 100px;
          height: 100px;
        }
      }
      .uploader {
        margin-left: 15px;
        height: 100px;
        width: 100px;
        margin-top: 3px;
      }
    }
  }
}

</style>